import React from "react";
import { getContact } from "./Contact";
// import geotrust from "../../images/geotrustssl.png";

export const getSideInfoPane = () => (
  <div className="padding-top-5">
    <div className="padding-top-10" />
    {getContact()}
    <div className="padding-top-20" />
    <div className="col-lg-2 col-md-2 col-sm-2" />
    {/* <div className="col-lg-4 col-md-4 col-sm-4">
      <a
        href="https://sealsplash.geotrust.com/splash?&amp;dn=app.locateplus.com"
        target="_blank"
        rel="noopener noreferrer"
        alt="Geo Trust SSL certificate for LocatePLUS which open in a new tab"
      >
        <img
          name="Geo Trust Secured"
          src={geotrust}
          alt="Click to Verify - This site has chosen a GeoTrust SSL Certificate to improve Web site security"
        />
      </a>
    </div> */}
    <div className="padding-top-20" />
    <div className="hide-on-smallscreen">
      <div className="padding-top-20" />

      <div className="padding-top-20" />

      <div className="padding-top-20" />
    </div>
    {/* <div
      className="col-lg-4 col-md-4 col-sm-4 hide-on-smallscreen"
      style={{ marginBottom: "20px" }}
    >
      <iframe
        src="https://www.whatismybrowser.com/feature/iframe?size=small&bgcolor=FFFFFF&font=Calibri&color=4f4f4f"
        title="Browser check with what is my browser"
        width="210"
        height="105px"
        className={"table-no-border"}
      />
    </div> */}
    <div className="padding-top-20" />
  </div>
);

export default getSideInfoPane;



// WEBPACK FOOTER //
// ./src/components/navigation/SideInfoPane.js